import {combineReducers} from "redux";
import settingHeader from "./settingHeader"


const systemConfigReducer = combineReducers({
    settingHeader,
});

export default systemConfigReducer;